import type { PayloadAction } from '@reduxjs/toolkit';

import type { ISessionInfo } from './models';

export const UPDATE_SESSION_INFO = 'session/updateSessionInfo';
export interface IUpdateSessionInfoPayload {
  sessionInfo: ISessionInfo;
}
export function updateSessionInfo(payload: IUpdateSessionInfoPayload)
  : PayloadAction<IUpdateSessionInfoPayload> {
  return {
    type: UPDATE_SESSION_INFO,
    payload,
  };
}
